// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    focusedItemText,
    focusedLinkStyles,
    itemText,
    linkStyles,
} from "@synd/App/SharedStyles/AutoCompleteSharedStyles";
import { autocompleteCategoriesStyles } from "@synd/Overrides/Widgets/Header/AutocompleteCategories";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { mergeWithCss } from "@synd/XDL/Utilities";
import { css } from "styled-components";

autocompleteCategoriesStyles.headerText = {
    variant: "h6",
    transform: "uppercase",
};

autocompleteCategoriesStyles.link = mergeWithCss(linkStyles, {
    typographyProps: {
        css: css`
            span > b {
                font-weight: ${fontConfig.weight.regular};
            }
        `,
    },
    css: css`
        margin-bottom: 12px;
    `,
});

autocompleteCategoriesStyles.focusedLink = mergeWithCss(focusedLinkStyles, {
    typographyProps: {
        css: css`
            span > b {
                font-weight: ${fontConfig.weight.regular};
            }
        `,
    },
    css: css`
        margin-bottom: 12px;
    `,
});

autocompleteCategoriesStyles.categoryItemText = itemText;

autocompleteCategoriesStyles.focusedCategoryItemText = focusedItemText;
